export const hotelCategories = ['5-star', '4-star', '3-star', 'Budget'];
